import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from 'vuex-persistedstate';
import cart from './modules/cart'
import account from './modules/account'
import payments from './modules/payments'
import shipments from './modules/shipments'
import restaurants from './modules/restaurants'

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {

    account,
    payments,
    shipments,
    restaurants,
    cart,
  },

  plugins: [createPersistedState({ storage: window.sessionStorage })],

});



// WEBPACK FOOTER //
// ./src/store/index.js